/**
 * Installation vs removal job service address node (for shipping / site block on summary).
 */

export function getJobServiceShipNode(
  io: any,
  isInstallationPublicSummary: boolean,
  isRemovalPublicSummary: boolean
): any | null {
  if (isInstallationPublicSummary) return io?.installation_details?.installation_address ?? null;
  if (isRemovalPublicSummary) return io?.removal_details?.removal_address ?? null;
  return null;
}
